
<ion-modal #modalPresenceForm  
    class="modal modal_presence_form"
    [canDismiss]="this.canDismissPresenceFormModal.bind(this)"
    (didDismiss)="this.onDidDismissPresenceFormModal($event)" 
    >   
    <ng-template>
        <ion-content class="ion-padding" scroll-y="false">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.closePresenceFormModal()"></ion-icon>
            </div>
            <div class="modal_presence_form_questions">
                @if(this.pcheck !== null && this.pcheck.formOnlineResponses !== null && this.pcheck.formOnlineResponses.length > 0){     
                    @for(formResponse of this.pcheck.formOnlineResponses; track $index){
                        <div>
                            <marv-field [label]="formResponse.rank + ' - ' + formResponse.question" icon="help-circle-outline" [value]="formResponse.answer"/>
                        </div>
                    }
                }
            </div>
        </ion-content>
    </ng-template>
</ion-modal>

<div class="mission_history"
    [class.is_clickable]="this.isClickable"    
    >
    <div class="mission_history_prefix">
        <div class="mission_history_date">
            {{this.mission.day | epochToString}}<ion-icon name="calendar-outline"></ion-icon>
        </div>
        <div class="mission_history_sep"></div>
    </div>
    <marv-item>
        <div class="mission_history_item" (click)="this.selectMission()">
            <app-operation-logo [operation]="this.getOperationLogo()" size="medium"/>                        
            <div class="mission_history_infos">
                <div class="mission_history_hour">
                    <ion-icon name="time-outline"></ion-icon>
                    @if(this.mission.amStartTime && this.mission.pmEndTime){
                        {{this.mission.amStartTime}} - {{this.mission.pmEndTime}}
                    }
                    @else if(this.mission.amStartTime){
                        {{this.mission.amStartTime}}
                    }
                    @else if(this.mission.pmStartTime){
                        {{this.mission.pmStartTime}}
                    }

                    @if(this.mission.duration){
                        @if(this.mission.amStartTime || this.mission.pmEndTime){
                            -
                        }
                        {{this.mission.duration}}
                    }
                                        
                </div>
                <div class="mission_history_profil">
                    <ion-icon name="person-outline"></ion-icon>
                    @if(this.mission.salesRep?.name){
                        {{this.mission.salesRep?.name}}
                    }
                    @else{
                        <div>
                            @if(this.mission.worker?.name){
                                {{this.mission.worker?.name}}
                            }
                            @else{
                                {{'PROFIL' | translate }} &laquo; {{this.mission.profil}} &raquo;
                            }
                            @if(this.mission.affected){
                                &nbsp;-&nbsp;<b>{{'AFFECTED' | translate}}</b>
                            }
                        </div>
                    }
                                        
                    @if(this.mission.recoCompliance){
                        <div class="mission_history_reco">{{'RECO' | translate}}</div>
                    }
                    
                </div>
                
                @if(this.displayOperation){
                    <div class="mission_history_op">
                        <marv-tag [color]="this.missionTypeService.getColor(this.mission.operation.typeOfMission)" size="small">{{this.mission.operation.name}}</marv-tag>
                    </div>
                }
                    
            </div>
                        
            @if(this.mission.showPresenceCheckInfos){
                <div class="mission_history_report">
                    <div>
                        {{'PRESENCE_CONFIRMED' | translate}}
                        @if(this.mission.presenceConfirmed){
                            <ion-icon name="thumbs-up-outline" class="green"></ion-icon>
                        }
                        @else{
                            <ion-icon name="thumbs-down-outline" class="orange"></ion-icon>
                        }       
                    </div>
                    @if(this.pcheck?.pcheckAlertValue){
                        <div class="mission_history_presence_alert">{{this.pcheck?.pcheckAlertValue}}</div>
                    }  
                    @if(this.mission.reportable){
                        <div>
                            {{'REPORTING_COMPLETED' | translate}}
                            @if(this.mission.reportingCompleted){
                                <ion-icon name="thumbs-up-outline" class="green"></ion-icon>
                            }
                            @else{
                                <ion-icon name="thumbs-down-outline" class="orange"></ion-icon>
                            } 
                        </div>
                    }
                </div>
            }
               
            
            <div class="mission_history_status">
                <div class="mission_history_status_label">
                    {{this.mission.status.name | translate}}
                </div>
                <div class="mission_history_status_icon">
                    <ion-icon [name]="this.mission.status.icon" [class]="this.mission.status.color"></ion-icon>
                </div>  
            </div>
                  
            <div class="mission_history_form">
                @if(this.pcheck !== null && this.pcheck.formOnlineResponses !== null && this.pcheck.formOnlineResponses.length > 0){                    
                    <marv-button type="button" label="{{ 'SEE_PRESENCE_FORM' | translate }}" color="primary" size="small" (click)="this.openPresenceFormModal($event)"/>                    
                }

                @if(this.mission.reportable && this.mission.source === 'loga'){
                    <div class="mission_history_reporting_link">
                        @if(this.isCraDisplayAllowed() && this.mission.reportingCompleted){
                            <div class="mission_history_reporting_link_available" (click)="this.openCra($event)">{{'SEE_REPORTING' | translate}} <ion-icon name="open-outline"></ion-icon></div>
                        }
                        @else{
                            <div class="mission_history_reporting_link_unavailable">{{'REPORTING_UNAVAILABLE' | translate}}</div>
                        }
                    </div>
                }
            </div>
            
            @if(this.mission.purposes){
                <div class="mission_history_purposes">
                    @for(purpose of this.mission.purposes; track $index){
                        <div class="mission_history_purpose" [class.fulfilled]="purpose.fulfilled">{{purpose.name}}</div>
                    }
                </div>
            }
                
            
        </div>
    </marv-item>
</div>  